import { render, staticRenderFns } from "./RosterEditDialog.vue?vue&type=template&id=f9675e24&scoped=true"
import script from "./RosterEditDialog.ts?vue&type=script&lang=ts&external"
export * from "./RosterEditDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./RosterEditDialog.scss?vue&type=style&index=0&id=f9675e24&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9675e24",
  null
  
)

export default component.exports